var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('BaseList',{ref:"pageRef",attrs:{"page-title":"下载中心","page-index-key":"pageNo","actions":_vm.actionBtns,"module-name":_vm.moduleName,"column-options":_vm.columnOptions,"search-btn-name":"查询","fetch-data-api":_vm.queryByPageDownload}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }